<template>
  <b-container class="the-detail">
    <b-form @submit.stop.prevent="update">
      <b-row align-h="between">
        <h1 class="pageheading">{{ $t('certificationBody.titles.update') }}</h1>
        <CRUDToolbar
          :clickFn="update"
          :hasBackButton="false"></CRUDToolbar>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('certificationBody.labelAsTitle.name') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="name"
              v-model="content.name">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('certificationBody.labelAsTitle.registrationNumber') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="certificateNr"
              v-model="content.registration_number">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.street') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="street"
              v-model="content.street">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.location') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="location"
              v-model="content.location">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.zip') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="zip"
              v-model="content.zip">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('certificationBody.labelAsTitle.country') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <Countries
              :preselect="content.country_id"
              v-on:country="setCountry"
              :showLabel="false">
            </Countries>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.phone') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              name="phone"
              id="phone"
              v-model="content.phone">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.fax') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="fax"
              v-model="content.fax">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.email') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              v-validate="{ required: true }"
              :class="{'validation--error': veeErrors.has('email') }"
              name="email"
              id="email"
              v-model="content.email">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.website') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="website"
              v-model="content.website">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.moreContacts') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-input
              id="moreContacts"
              v-model="content.more_contacts">
            </b-form-input>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.intern_field') }}</h3>
        <b-row class="detailsection__content">
          <b-col>
            <b-form-textarea
              id="internField"
              v-model="content.intern_field">
            </b-form-textarea>
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">{{ $t('owner.labelAsTitle.logo') }}</h3>
        <b-row class="detailsection__content">
          <b-col
            cols="3"
            align-self="center"
            v-if="!showLogo">
            <img
              class="logo"
              :src="logoURL"/>
          </b-col>
          <b-col :cols="content.logo ? 9 : 12">
            <FileInput
              :preSelect="logoType()"
              :preSelectValue="this.content.logo_url ? this.content.logo_url : null"
              v-on:setFile="setFile" />
          </b-col>
        </b-row>
      </b-row>
      <b-row class="detailsection detailsection--productcategory">
        <h3 class="detailsection__heading">SCOPE OF EMPOWERMENT</h3>
        <Assignment
          :class="{ 'validation--error': !showAssignmentError }"
          v-model="content.assignments" />
      </b-row>
      <CRUDToolbar :clickFn="update"></CRUDToolbar>
    </b-form>
  </b-container>
</template>

<script>
import CRUDToolbar from '../components/CRUDToolbar'
import Countries from '../components/Selects/Countries'
import { toaster } from '../services/toast'
import FileInput from '../components/FileInput'
import Assignment from '../components/Assignment'
import jsonToFormData from 'json-form-data'

export default {
  name: 'TheCertificationBodyUpdate',
  components: {
    CRUDToolbar,
    Countries,
    FileInput,
    Assignment
  },
  computed: {
    /**
     * @return {boolean}
     */
    showAssignmentError () {
      return this.isValid()
    },
    /**
     *
     * @return {*}
     */
    logoURL () {
      return this.content.logo
        ? this.content.logo
        : this.content.logo_url
          ? this.content.logo_url
          : null
    },
    /**
     *
     * @return {string|boolean|*}
     */
    showLogo () {
      const hasFile = this.content.logo && (this.content.logo instanceof File)

      return hasFile || this.content.logo_url
    }
  },
  /**
   *
   * @return {{toggleError: boolean, content: {}}}
   */
  data () {
    return {
      content: {},
      toggleError: false
    }
  },
  /**
   *
   * @param to
   * @param from
   * @param next
   *
   * @return {void}
   */
  beforeRouteEnter (to, from, next) {
    const { id } = to.params

    if (!id) {
      next(false)
      return
    }

    next(async vue => {
      const { data } = await vue.$api.get(`certificationBodies/${id}`)

      vue.content = data
    })
  },
  methods: {
    isValid () {
      if (!('assignments' in this.content)) {
        return false
      }

      const countAssignments = this.content.assignments.filter(
        item => item.laboratory_id && item.product_type_id
      ).length

      return this.content.assignments.length === countAssignments
    },
    /**
     * @return {string|null}
     */
    logoType () {
      return this.content.logo
        ? 'logo'
        : this.content.logo_url
          ? 'logo_url'
          : null
    },
    /**
     *
     * @param value
     *
     * @return {void}
     */
    setAssignments (value) {
      this.$set(this.content, 'assignments', value)
    },
    /**
     *
     * @param value
     * @param logoType
     *
     * @return {void}
     */
    setFile ({ value, logoType }) {
      if (logoType === 'logo' && ('logo_url' in this.content)) {
        Reflect.deleteProperty(this.content, 'logo_url')
      }

      if (logoType === 'logo_url' && ('logo' in this.content)) {
        Reflect.deleteProperty(this.content, 'logo')
      }

      this.content[logoType] = value
    },
    /**
     *
     * @return {Promise<void>}
     */
    async update () {
      const initToaster = toaster(this['_bv__toast'])
      const validatedAll = await this.$validator.validateAll()

      if (!validatedAll || !this.isValid()) return

      if (this.content.logo instanceof File === false && this.content.logo) {
        Reflect.deleteProperty(this.content, 'logo')
      }

      try {
        const formData = jsonToFormData(this.content)
        const { data } = await this.$api.create(`certificationBodies/${this.content.id}`, formData)

        initToaster(200)(this.$t('notifications.success.title'), this.$t(`notifications.success.${200}`))

        this.$router.push(`/certificationBodies/${data.id}/detail`)
      } catch ({ data }) {
        const toaster = initToaster(data.message)

        toaster(this.$t('notifications.error.title'), this.$t(`notifications.error.${data.status_code}`))
      }
    },
    /**
     *
     * @param value
     *
     * @return {void}
     */
    setCountry (value) {
      this.content.country_id = value
    }
  }
}
</script>
